import Site from './site';

export default Site;
